export const regexUrl = /(((https?:\/\/)|(www\.|Www\.))[^\s]+)/g;
